/*
  DEROS: swaps the mega menu's picture as the visitor hovers (or focuses) an
  element carrying data-deros-image: a column in the Collections menu, a brand
  link in the Brands menu. The default picture returns when the menu closes.
  The next picture is decoded before it replaces the current one, so there is
  no blank frame while it loads.
*/

class DerosMegaMenu extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('.deros-mega-menu__image');
    if (!this.image) return;

    this.defaultSrc = this.image.getAttribute('data-deros-default') || '';
    this.current = this.defaultSrc;

    this.addEventListener('mouseover', this.onHover);
    this.addEventListener('focusin', this.onHover);

    this.details = this.closest('details');
    this.details?.addEventListener('toggle', this.onToggle);
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.onToggle);
    this.details = null;
  }

  onToggle = () => {
    if (!this.details.open) this.show(this.defaultSrc);
  };

  onHover = (event) => {
    const target = event.target.closest('[data-deros-image]');
    if (!target || !this.contains(target)) return;
    this.show(target.getAttribute('data-deros-image'));
  };

  show(src) {
    if (src === this.current) return;
    this.current = src;

    if (!src) {
      this.image.hidden = true;
      return;
    }

    const next = new Image();
    next.src = src;
    next
      .decode()
      .then(() => {
        if (this.current !== src) return;
        this.image.src = src;
        this.image.hidden = false;
      })
      .catch(() => {
        // Keep the picture that is showing; let the same item be tried again.
        if (this.current === src) this.current = null;
      });
  }
}

if (!customElements.get('deros-mega-menu')) {
  customElements.define('deros-mega-menu', DerosMegaMenu);
}
